// La nomenclature des espaces : types de groupe, catégories de page.
//
// Ce fichier ne dépend de RIEN — ni de la base, ni de l'affichage, ni de React.
// C'est voulu : ces listes sont lues par les écrans en HTML, par les composants
// React, et par les pages de détail. Les laisser dans `views/groupes.js` créait
// un cycle d'imports dès que le composant React de la liste avait besoin de
// l'étiquette d'un type — et un cycle d'imports, on en a déjà payé un cette
// nuit (voir `voisinageEnCours` dans signaux.js).
//
// Un groupe est un lieu d'échange, une page est une voix : c'est pourquoi l'un a
// des types d'activité et l'autre des catégories d'institution.

export const TYPES_GROUPE = [
  { id: "priere", label: "Groupe de prière", icone: "🙏" },
  { id: "departement", label: "Département", icone: "👥" },
  { id: "jeunes", label: "Jeunesse", icone: "✨" },
  { id: "etude", label: "Étude biblique", icone: "📖" },
  { id: "autre", label: "Autre", icone: "🕊️" },
];

export const CATEGORIES = [
  { id: "eglise", label: "Église", icone: "⛪" },
  { id: "ministere", label: "Ministère", icone: "🕊️" },
  { id: "chorale", label: "Chorale", icone: "🎶" },
  { id: "association", label: "Association", icone: "🤝" },
  { id: "autre", label: "Autre", icone: "📄" },
];

// « Autre » sert de refuge : un identifiant inconnu — venu d'une version plus
// récente, ou d'une donnée abîmée — ne doit jamais faire disparaître la carte.
export const typeDe = (id) => TYPES_GROUPE.find((t) => t.id === id) || TYPES_GROUPE[4];
export const categorieDe = (id) => CATEGORIES.find((c) => c.id === id) || CATEGORIES[4];
